import { createContext, useContext } from 'react';

// Drawer control, handed DOWNWARD from App; the inert default and the cross-tab hop it does
// NOT replace are both covered in .claude/context/composition-topology.md.
const NOOP_DRAWER_CONTROL = Object.freeze({
  openDrawer: () => {},
});

export const DrawerControlContext = createContext(NOOP_DRAWER_CONTROL);

/**
 * Drawer commands available to the assistant subtree.
 * @returns {{ openDrawer: () => void }}
 */
export const useDrawerControl = () => useContext(DrawerControlContext);
